const handleUpdateCharacterCreatorState = (field, value, characterCreatorState, setCharacterCreatorState) =>{
    let tempCharacterCreatorState = {...characterCreatorState};
    tempCharacterCreatorState[field] = value
    setCharacterCreatorState(tempCharacterCreatorState)
    console.log(characterCreatorState)
}

export default handleUpdateCharacterCreatorState